/*
 * @Author: yinhongwei 
 * @Date: 2021-08-20 15:51:29 
 * @Last Modified by: yinhongwei
 * @Last Modified time: 2023-05-31 14:08:31
 * @Description: 公共的样式库
 */
import { StyleSheet, Dimensions } from "react-native";

const CommonScreenWidth = Dimensions.get("window").width;
const CommonScreenHeight = Dimensions.get("window").height;

const CommonStyled = StyleSheet.create({
  // Nav聊天图标
  iconChat: {
    width: 30, 
    height: 30
  },
  // Nav好友图标
  iconFriends: {
    width: 30, 
    height: 30,
    marginRight: 15
  },
  // Nav设置图标
  iconSetting: {
    width: 24, 
    height: 24, 
    marginLeft: 10, 
    marginRight: 15
  },
  // Nav分享图标
  iconShare: {
    width: 26, 
    height: 26, 
    marginLeft: 10, 
    marginRight: 15
  },
  // 排一行 两端对齐
  rowLine: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  // 排一行 左对齐
  rowLineLeft: {
    flexDirection: "row",
    alignItems: "flex-end",
    flexWrap: "wrap"
  },
  // 排一行 左对齐居中
  rowLineLeftCenter: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap"
  },
  // 排一行 居中对齐
  rowLineCenter: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  // 空内容
  emptyTips: {
    height: CommonScreenHeight - 150,
    paddingTop: (CommonScreenHeight - 150) / 2,
    textAlign: "center",
    fontSize: 15,
    justifyContent: "center",
    color: "#ada8a8",
  },
  // 关闭按钮1
  closeButton: {
    width: 45,
    height: 45,
    alignItems: "center",
    justifyContent: "center"
  },
  // 关闭按钮2
  closeText: {
    fontSize: 20,
    paddingTop: 2,
    includeFontPadding: false,
    color: "#FFF"
  },
  // 主要按钮 配合使用[buttonPrimary, buttonPrimaryTxt]
  buttonPrimaryTxt: {
    fontSize: 16,
    color: "#ffffff",
  },
  buttonPrimary: {
    borderRadius: 5,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#f70f0f",
    backgroundColor: "#f70f0f",
    textAlign: "center",
    alignItems: "center",
    paddingVertical: 3,
    paddingHorizontal: 6
  },
  // 默认按钮 配合使用[buttonDefault, buttonDefaultTxt]
  buttonDefaultTxt: {
    fontSize: 16,
    color: "#323233"
  },
  buttonDefault: {
    borderRadius: 5,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#ebedf0",
    backgroundColor: "#ffffff",
    textAlign: "center",
    alignItems: "center",
    paddingVertical: 3,
    paddingHorizontal: 6
  },
  // 按钮增加宽度和高度
  buttonExtendSize: {
    width: 150,
    height: 35,
    lineHeight: 29
  },
  // 滚动到顶部的按钮
  buttonScrollTop: { 
    position: "absolute",
    right: 10,
    bottom: 100,
    backgroundColor: "#ffffff",
    borderWidth: 0,
    borderRadius: 50,
    overflow: "hidden"
  },
  // 容器1 （场景：文章列表）
  wrapStyleSimple: {
    borderRadius: 5,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#ebedf0",
    backgroundColor: "#ffffff",
    paddingVertical: 6,
    paddingHorizontal: 9,
    marginBottom: 15,
  },
  // 必填字段 *
  requiredFlag: {
    color: "red",
    alignItems: "center",
  },
  // 距离顶部10
  marginT10: {
    marginTop: 10
  },
  // 距离右侧10
  marginR10: {
    marginRight: 10
  },
  // 距离底部10
  marginB10: {
    marginBottom: 10
  },
  // 距离右侧和底部10
  marginRB10: {
    marginRight: 10,
    marginBottom: 10
  },
  // 预览图片的数字展示
  imagePreviewNumber: {
    fontSize: 15,
    color: "white",
    marginLeft: CommonScreenWidth / 2 - 15
  },
  // 预览图片的底部文字展示
  imagePreviewBottom: {
    backgroundColor: "rgba(0, 0, 0, .3)",
    paddingVertical: 10,
    flex: 1
  },
  imagePreviewBottomText: {
    fontSize: 15,
    color: "white",
    textAlign: "center"
  },
  // 头像相关的样式
  headImgWrap: {
    width: 50,
    height: 50,
    borderWidth: 2,
    borderColor: "#f38b8b",
    borderRadius: 50,
    overflow: "hidden",
    marginRight: 10
  },
  headImg: {
    width: 46, 
    height: 46, 
    borderRadius: 46, 
    overflow: "hidden"
  },
});

export default CommonStyled;